import React, { useState } from 'react';
import { GroupMembers } from '../GroupMembers';
import { GroupInfo } from '../GroupInfo';
import { GroupSelector } from '../GroupSelector';



// GROUP PAGE

export function GroupLayout(props) {
  const { group = {}, members, invited = [], admins = [], fetchInvited, fetchMembers, fetchGroup, requestToJoin } = { ...props };
  const [groupBrowser, setGroupBrowser] = useState();

  return (
    <>



      <div className="x_people0 active">
        <GroupSelector
          group={group}
          members={members}
          invited={invited}
          admins={admins}
          expanded={groupBrowser}
          setExpanded={setGroupBrowser}
          onAdd={() => {
            fetchMembers?.();
            fetchInvited?.();
            fetchGroup?.();
          }}
        />
        <div className="x_choose_panel active">
          <div className="x_choose0 active">
            <div className="x_people_panel active">
              <div className="x_choose_left x_choose_left--open">
                <div className="x_choose_container x_choose_container--v">
                  <div className="x_panel_h0" />

                  <div className="x_choose_contents">
                    <div className="_fv _fgap0">

                      <GroupInfo
                        {...props}
                        groupBrowser={groupBrowser}
                        setGroupBrowser={setGroupBrowser}
                      />

                      <GroupMembers
                        group={group}
                        members={members}
                        admins={admins}
                        requestToJoin={requestToJoin}
                        fetchMembers={fetchMembers}
                        fetchGroup={fetchGroup}
                        fullSrceen
                      />

                    </div>
                  </div>





                </div>
              </div>

            </div>
            <div className="x_choose_bg"><div className="x_edu_bg g" /></div>


          </div>
        </div>
      </div>

      {/* <div className="x_choose_bg"><div className="x_edu_bg g" /></div> */}


    </>
  )
}
